import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_LIST_REQUEST,
  FETCH_DJUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_LIST_SUCCESS,
  FETCH_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_ERROR,
  UPDATE_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_REQUEST,
  UPDATE_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_SUCCESS,
  GET_PAGES,
} from 'actionTypes'

const getPages = (metadata) => ({
  type: GET_PAGES,
  pages: metadata.pageCount,
  current: metadata.page,
  count: metadata.totalCount,
})

export const fetchList =
  (token, page = 1) =>
  (dispatch) => {
    dispatch(fetchListRequest())

    return new Api(token, dispatch)
      .get(API_URL.JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION, {
        page,
      })
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(getPages(response.data.pagination))
        dispatch(fetchListSuccess(response.data.listPresenter))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchError(error))
        dispatch(hideSpinner())
      })
  }

export const fetchListRequest = () => ({
  type: FETCH_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_LIST_REQUEST,
})

export const fetchListSuccess = (data) => ({
  type: FETCH_DJUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_LIST_SUCCESS,
  payload: data,
})

export const fetchError = (error) => ({
  type: FETCH_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_ERROR,
  payload: error,
})

export const updateJustification = (token, values) => (dispatch) => {
  dispatch(updateJustificationRequest())

  return new Api(token, dispatch)
    .post(`${API_URL.JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION}/save`, {
      ...values,
    })
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(updateJustificationSuccess(response.data))
      dispatch(fetchList(token))
    })
    .catch((error) => {
      dispatch(fetchError(error))
    })
    .finally(() => dispatch(hideSpinner()))
}

export const updateJustificationRequest = () => ({
  type: UPDATE_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_REQUEST,
})

export const updateJustificationSuccess = (data) => ({
  type: UPDATE_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_SUCCESS,
  payload: data,
})

export const removeJustification =
  (token, idJustificationDisapprovalUseConsumption) => (dispatch) =>
    new Api(token, dispatch)
      .post(`${API_URL.JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION}/delete`, {
        idJustificationDisapprovalUseConsumption,
      })
      .then(dispatch(showSpinner()))
      .then(() => {
        dispatch(fetchList(token))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchError(error))
        dispatch(hideSpinner())
      })
